import { render, staticRenderFns } from "./WorkerRow.vue?vue&type=template&id=4e83b75c&scoped=true&"
import script from "./WorkerRow.vue?vue&type=script&lang=js&"
export * from "./WorkerRow.vue?vue&type=script&lang=js&"
import style0 from "./WorkerRow.vue?vue&type=style&index=0&id=4e83b75c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e83b75c",
  null
  
)

export default component.exports